import { render, staticRenderFns } from "./UserSelectedShop.vue?vue&type=template&id=61004bbc&scoped=true&"
import script from "./UserSelectedShop.vue?vue&type=script&lang=js&"
export * from "./UserSelectedShop.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectedShop.vue?vue&type=style&index=0&id=61004bbc&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61004bbc",
  null
  
)

export default component.exports